import { useState, useEffect } from "react";
import { useUser } from "util/context/user_context";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  useLocation,
  useNavigate,
  replace,
} from "react-router-dom";
import { emptyCheck } from "util/function/function";

import NormalMainScreen from "screen/normal/desktop/normal_main_screen";
import NormalMainMobile from "screen/normal/mobile/normal_main_mobile";
import RegisterScreen from "screen/login/register/desktop/register_screen";
import LandingMainScreen from "screen/landing/desktop/landing_main_screen";
import LandingMainMobile from "screen/landing/mobile/landing_main_mobile";
import LoginScreen from "screen/login/desktop/login_screen";
import Footer from "components/footer/footer";
import Header from "components/header/header";
import MatchingMainScreen from "screen/repair/desktop/matching_main_screen";
import DesktopCommunityScreen from "screen/community/desktop/desktop_community_screen";
import DesktopCommunityDetailScreen from "screen/community/desktop/desktop_community_detail_screen";
import MatchingDetailScreen from "screen/repair/desktop/matching_detail_screen";
import ExpertMainScreen from "screen/expert/desktop/expert_main_screen";
import MobileFooter from "components/footer/footer_m";
import FixRequestMobile from "screen/fix_request/mobile/fix_request_mobile";
import FixRequestWriteMobile from "screen/fix_request/mobile/fix_request_write_mobile";
import MobileCommunityScreen from "screen/community/mobile/mobile_community_screen";
import MobileMatchingMainScreen from "screen/repair/mobile/mobile_matching_main_screen";
import ExpertMainMobile from "screen/expert/mobile/expert_main_mobile";
import ExpertReceivedScreen from "screen/expert/desktop/expert_recieved_screen";
import ExpertPointChargeScreen from "screen/expert/desktop/expert_point_charge_screen";
import ExpertPointHistoryScreen from "screen/expert/desktop/expert_point_history.screen";
import ExpertMatchingScreen from "screen/expert/desktop/expert_matching_screen";
import LoadingScreen from "screen/login/desktop/loading_screen";
import CommunityWriteScreen from "screen/community/desktop/desktop_community_write_screen";
import CommunityEditScreen from "screen/community/desktop/desktop_community_edit_screen";
import FixRequestEditMobile from "screen/fix_request/mobile/fix_request_edit_mobile";
import DesktopInquiryScreen from "screen/inquiry/desktop/desktop_inquiry_screen";
import DesktopInquiryDetailScreen from "screen/inquiry/desktop/desktop_inquiry_detail_screen";
import DesktopInquiryWriteScreen from "screen/inquiry/desktop/desktop_inquiry_write_screen";
import MyPageScreen from "screen/my/mypage_screen";
import TermPage from "screen/term/termPage";
import PolicyPage from "screen/term/policyPage";
import AdminScreen from "screen/admin/admin_screen";
import NotificationsScreen from "screen/notifications/notifications_screen";
import NotificationSettingsScreen from "screen/notifications/notification_settings_screen";

function AppWithAuth() {
  const location = useLocation();
  const { userData, setUserData } = useUser();
  // const navigate = useNavigate();
  const isRootPath =
    location.pathname === "/" ||
    location.pathname === "/register" ||
    location.pathname === "/landing" ||
    location.pathname === "/loading" ||
    location.pathname === "/terms" ||
    location.pathname === "/miadmin" ||
    location.pathname.startsWith("/miadmin/");
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    handleResize();
  }, []);

  // 유저 데이터 체크
  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      setIsLoading(false);
    }
  }, [userData]);

  // 화면 크기 체크
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 620);
    const handleResize = () => setIsMobile(window.innerWidth <= 620);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  };

  if (isLoading) {
    return (
      <>
        <Routes>
          <Route path="/miadmin/*" element={<AdminScreen />} />
          <Route path="/" element={<LoginScreen isMobile={isMobile} />} />
          <Route
            path="/register"
            element={<RegisterScreen isMobile={isMobile} />}
          />
          <Route path="/terms" element={<TermPage />} />
          <Route path="/policy" element={<PolicyPage />} />
          <Route path="/loading" element={<LoadingScreen />} />
          <Route
            path="/landing"
            element={isMobile ? <LandingMainMobile /> : <LandingMainScreen />}
          />
        </Routes>
      </>
    );
  } else {
    return (
      <>
        {!isRootPath && <Header isMobile={isMobile} />}

        <Routes>
          <Route path="/miadmin/*" element={<AdminScreen />} />
          <Route path="/terms" element={<TermPage />} />
          <Route path="/policy" element={<PolicyPage />} />
          <Route
            path="/mypage"
            element={<MyPageScreen isMobile={isMobile} />}
          />
          <Route
            path="/notifications"
            element={
              userData ? (
                <NotificationsScreen isMobile={isMobile} />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/notifications/settings"
            element={
              userData ? (
                <NotificationSettingsScreen isMobile={isMobile} />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route path="/" element={<LoginScreen isMobile={isMobile} />} />
          <Route
            path="/register"
            element={<RegisterScreen isMobile={isMobile} />}
          />
          <Route
            path="/main"
            element={
              userData && userData["userType"] == "농가" ? (
                isMobile ? (
                  <NormalMainMobile />
                ) : (
                  <NormalMainScreen />
                )
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/expertmain"
            element={
              userData && userData["userType"] == "수리기사" ? (
                isMobile ? (
                  <ExpertMainMobile />
                ) : (
                  <ExpertMainScreen />
                )
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/addpoint"
            element={
              userData && userData["userType"] == "수리기사" ? (
                <ExpertPointChargeScreen isMobile={isMobile} />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/payhistory"
            element={
              userData && userData["userType"] == "수리기사" ? (
                <ExpertPointHistoryScreen />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/matching"
            element={
              userData && userData["userType"] == "농가" ? (
                isMobile ? (
                  <MobileMatchingMainScreen />
                ) : (
                  <MatchingMainScreen />
                )
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/matching/:docId"
            element={
              userData && userData["userType"] == "농가" ? (
                <MatchingDetailScreen isMobile={isMobile} />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/community"
            element={
              userData ? (
                isMobile ? (
                  <MobileCommunityScreen />
                ) : (
                  <DesktopCommunityScreen />
                )
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/community/:docId"
            element={
              userData ? (
                <DesktopCommunityDetailScreen />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/community/write"
            element={
              userData ? (
                <CommunityWriteScreen isMobile={isMobile} />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/community/edit/:docId"
            element={
              userData ? (
                <CommunityEditScreen isMobile={isMobile} />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />

          <Route
            path="/fix_request"
            element={
              userData && userData["userType"] == "농가" ? (
                <FixRequestMobile />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/fix_request/write"
            element={
              userData && userData["userType"] == "농가" ? (
                <FixRequestWriteMobile />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route path="/fix_request/:docId" element={<FixRequestMobile />} />
          <Route
            path="/fix_request/edit/:docId"
            element={
              userData && userData["userType"] == "농가" ? (
                <FixRequestEditMobile />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          {/* <Route
            path="/select_category"
            element={
              userData && userData["userType"] == "농가" ? (
                <SelectCategoryMobile />
              ) : (
                <FixRequestEditMobile />
              )
            }
          /> */}
          <Route
            path="/received"
            element={
              userData && userData["userType"] == "수리기사" ? (
                <ExpertReceivedScreen />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/received/:docId"
            element={
              userData && userData["userType"] == "수리기사" ? (
                <MatchingDetailScreen isMobile={isMobile} />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/matching_done"
            element={
              userData && userData["userType"] == "수리기사" ? (
                <ExpertMatchingScreen />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/matching_done/:docId"
            element={
              userData && userData["userType"] == "수리기사" ? (
                <MatchingDetailScreen isMobile={isMobile} />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/inquiry"
            element={<DesktopInquiryScreen isMobile={isMobile} />}
          />
          <Route
            path="/inquiry/:docId"
            element={<DesktopInquiryDetailScreen />}
          />
          <Route
            path="/inquiry/write"
            element={
              userData ? (
                <DesktopInquiryWriteScreen />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
        </Routes>

        {!isRootPath && (isMobile ? <MobileFooter /> : <Footer />)}
      </>
    );
  }
}

export default AppWithAuth;
